import { TwoColumnLayout } from 'layouts';
import type { PublicGivingContentObject } from 'models';
import type { TransactionResultParams } from 'features/transactions';
import { DescriptionCard, DonateButtons, SharingButtons } from '../../components';
import { PublicGivingHeader } from '../../public-giving-header';

type P = {
  giveTransaction: TransactionResultParams;
  givingContentObject: PublicGivingContentObject;
  paymentRedirectUrl: string;
};

const PublicGivingContent = ({ giveTransaction, givingContentObject, paymentRedirectUrl }: P) => {
  const { giving } = givingContentObject;

  return (
    <>
      <PublicGivingHeader givingContentObject={givingContentObject} />
      <TwoColumnLayout
        left={
          <>
            <DonateButtons giveTransaction={giveTransaction} giving={giving} paymentRedirectUrl={paymentRedirectUrl} />
            <DescriptionCard giving={giving} />
          </>
        }
        right={<>{giving.status === 'ongoing' ? <SharingButtons card giving={giving} /> : null}</>}
      />
    </>
  );
};

export default PublicGivingContent;
